import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialGithubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialGithub",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M16.01 0C7.16 0 0 7.21 0 16.13c0 7.13 4.59 13.17 10.95 15.3.8.16 1.09-.35 1.09-.77 0-.37-.03-1.66-.03-2.99-4.45.96-5.38-1.92-5.38-1.92-.72-1.87-1.78-2.35-1.78-2.35-1.46-.99.11-.99.11-.99 1.62.11 2.47 1.66 2.47 1.66 1.43 2.46 3.74 1.76 4.67 1.33.13-1.04.56-1.76 1.01-2.16-3.55-.37-7.29-1.76-7.29-7.96 0-1.76.64-3.2 1.64-4.33-.16-.4-.72-2.06.16-4.27 0 0 1.35-.43 4.4 1.66 1.31-.35 2.65-.53 4-.53s2.73.19 4 .53c3.05-2.08 4.4-1.66 4.4-1.66.88 2.22.32 3.87.16 4.27 1.03 1.12 1.64 2.56 1.64 4.33 0 6.2-3.74 7.56-7.32 7.96.58.51 1.09 1.47 1.09 2.99 0 2.16-.03 3.9-.03 4.43 0 .43.29.93 1.09.77A16.12 16.12 0 0 0 32 16.13C32.03 7.21 24.84 0 16.01 0"
    })
  }));
};
SocialGithubIcon.displayName = 'SocialGithubIcon';